import axios from "axios";

const API = axios.create({
  baseURL: "https://vanadevaraibackend.onrender.com/api",
});

/* 🌿 Activity APIs */
export const createActivity = (data) => API.post("/activities", data);
export const getActivities = () => API.get("/activities");

/* 📸 Image APIs */
export const uploadImage = (formData) =>
  API.post("/images/upload", formData);

export const getImagesByActivity = (id) =>
  API.get(`/images/${id}`);